import React from "react";
import "../css/CareerHero.css";

const CareerHero = () => {
  const scrollToPositions = () => {
    const element = document.getElementById("open-positions-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="career-hero-container">
      <div className="career-hero-overlay">
        <div className="career-hero-content">
          <h1>Build Your Career With Us</h1>
          <p>Join a passionate team shaping the future of education</p>

          {}
          <button className="explore-jobs-btn" onClick={scrollToPositions}>
            Explore Services
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareerHero;
